import type { CSSProperties } from 'react'

export enum Colors {
  DARK_RED = '#c72e11',
  RED = '#f73e31',
  GREY = '#9AA0A6',
  BUTTON_GREEN = 'rgba(53,89,62,1)',
  LIGHT_LIGHT_GREEN = 'rgba(141,227,190,1)',
  LIGHT_GREEN = 'rgba(26,42,35,1)',
  DARK_GREEN = 'rgba(18,34,27,1)',
  YELLOW = '#fad637',
  ORANGE = '#ff8c00',
  BLACK = '#000000',
  WHITE = '#F6F7EB'
}

export const actuatorDispositionStyle: CSSProperties = {
  borderRadius: 6,
  border: '2px solid #888',
  padding: 2,
  fontWeight: 'bold'
}
